import {
  BackIcon,
  MedicalProfessionalMonochromeIcon,
  PatientsIcon,
  PermissionsIcon,
  DialogueBubbleIcon,
  NoteIcon,
} from '@honestica/curecall-ui'
import Sidebar from 'src/components/navigation/sidebar.component'
import { useTranslation } from 'react-i18next'
import { TMenuTab } from 'src/components/navigation/sidebar-tabs.component'
import { useCurrentProject } from 'src/providers/current-project.provider'
import {
  EPermissionGrantActions,
  EPermissionGrantSubjects,
} from '../permissions/_components/permissions.type'

const ConfigurationSidebar = () => {
  const { t } = useTranslation()
  const { project } = useCurrentProject()

  const configurationSubItems: TMenuTab[] = [
    {
      path: `/${project.id}/configuration/contents`,
      label: t('pages.configuration.content-list'),
      IconComponent: NoteIcon,
      requiredPermission: {
        subject: EPermissionGrantSubjects.CONFIGURATION,
        action: EPermissionGrantActions.GET,
      },
    },
    {
      path: `/${project.id}/configuration/messages`,
      label: t('pages.configuration.message-list'),
      IconComponent: DialogueBubbleIcon,
      requiredPermission: {
        subject: EPermissionGrantSubjects.CONFIGURATION,
        action: EPermissionGrantActions.GET,
      },
    },
  ]

  const configurationMenuTabs: TMenuTab[] = [
    {
      path: `/${project.id}/configuration/followups`,
      label: t('components.navigation.configuration'),
      IconComponent: PatientsIcon,
      subItems: configurationSubItems,
      // No `requiredPermission` because this is the default page for the configuration space, the user will always land
      // on this page when going to configuration, it may have access to other elements but not this one. This item should
      // still be displayed to avoid confusing the user
    },
    {
      path: `/${project.id}/configuration/permissions`,
      label: t('components.navigation.permissions'),
      IconComponent: PermissionsIcon,
      requiredPermission: {
        subject: EPermissionGrantSubjects.USER_MANAGEMENT,
        action: EPermissionGrantActions.GET,
      },
    },
    {
      path: `/${project.id}/configuration/medical-staff-members`,
      label: t('components.navigation.medical-staff-members'),
      IconComponent: MedicalProfessionalMonochromeIcon,
      requiredPermission: {
        subject: EPermissionGrantSubjects.USER_MANAGEMENT,
        action: EPermissionGrantActions.GET,
      },
    },
    {
      path: `/${project.id}/medical`,
      label: t('components.navigation.back-to-medical'),
      IconComponent: BackIcon,
    },
  ]

  return <Sidebar menuTabs={configurationMenuTabs} backgroundClass="c-bg-gradient-06" />
}

export default ConfigurationSidebar
